<script>
import bem from '@/utils/bem';
import { mapActions, mapGetters, mapState } from 'vuex';
import CreateNewRush from '@/components/modals/Create-new-rush.vue';
import EditRush from '@/components/modals/Edit-rush.vue';
import columns from './columns';

const b = bem('rushes-page');

export default {
  props: {
    companyId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      showCreate: false,
      showEdit: false,
      selectedId: null,
    };
  },
  components: {
    CreateNewRush,
    EditRush,
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      getRushesAction: 'rushes/getRushes',
      changeRushAction: 'rushes/changeRush',
      deleteRushAction: 'rushes/deleteRush',
      getCompaniesAction: 'companies/getCompanies',
    }),
    openCreateWindow() {
      this.showCreate = true;
    },
    openEditWindow(id) {
      this.selectedId = id;
      this.showEdit = true;
    },
    getRushes() {
      this.getRushesAction();
    },
    changeRush(
      {
        id,
        percent,
        enhance,
        photoArt,
        digitize,
        isDefault,
        companyId,
      },
    ) {
      this.changeRushAction({
        id,
        percent,
        enhance,
        photoArt,
        digitize,
        isDefault,
        companyId: companyId || this.companyId || null,
      });
    },
    deleteRush(id) {
      this.deleteRushAction(id);
    },
  },
  mounted() {
    this.getRushes();
    if (!this.companyId) {
      this.getCompaniesAction({ limit: 1000, offset: 0 });
    }
  },
  computed: {
    ...mapGetters({
      sortedRushes: 'rushes/sortedRushes',
    }),
    ...mapState({
      companies: (state) => state.companies.companies,
    }),
    companyIdToName() {
      const map = {};
      (this.companies || []).forEach((c) => {
        map[c.id] = c.displayName;
      });
      return map;
    },
    companyFilters() {
      return (this.companies || []).map((c) => ({ text: c.displayName, value: c.id }));
    },
    tableColumns() {
      const cols = columns(this.companyFilters);
      if (this.companyId) {
        return cols.filter((c) => c.key !== 'companyId');
      }
      return cols;
    },
    companyOptions() {
      return (this.companies || []).map((c) => ({ label: c.displayName, value: c.id }));
    },
    filteredRushes() {
      if (this.companyId) {
        return this.sortedRushes.filter((rush) => rush.companyId === Number(this.companyId));
      }
      return this.sortedRushes;
    },
  },
  watch: {
    companyId() {
      this.getRushes();
    },
  },
};
</script>

<template>
  <div :class="b()">
    <div :class="b('create-button')">
      <a-button
        type="primary"
        html-type="button"
        @click="openCreateWindow"
      >
        Create new rush
      </a-button>
    </div>
    <div v-if="showCreate">
      <CreateNewRush
        v-model:show="showCreate"
        :company-options="companyOptions"
        :company-id="companyId"
      />
    </div>
    <div :class="b('table')">
      <a-table
        :columns="tableColumns"
        :dataSource="filteredRushes"
        :pagination="false"
      >
        <template #bodyCell="{ column, text, record }">
          <template v-if="column.dataIndex === 'companyId'">
            <span>
              {{
                record.companyId
                  ? (companyIdToName[record.companyId] || record.companyId)
                  : '-'
              }}
            </span>
          </template>
          <template v-if="column.dataIndex === 'isDefault'">
            <div >
              <a-switch
                :checked="text"
                @change="changeRush({...record, isDefault: !text})"
              >
              </a-switch>
            </div>
          </template>
          <template v-else-if="column.dataIndex === 'actions'">
            <div :class="b('action-buttons')">
              <a-button
                type="primary"
                html-type="button"
                @click="openEditWindow(record.id)"
              >
                Edit
              </a-button>
              <div v-if="showEdit && selectedId && selectedId === record.id">
                <EditRush
                  v-model:show="showEdit"
                  :rush-info="record"
                  :company-options="companyOptions"
                  :company-id="companyId"
                />
              </div>
              <a-popconfirm title="Sure to delete?" @confirm="deleteRush(record.id)">
                <a-button type="primary" html-type="button" danger>
                  Delete
                </a-button>
              </a-popconfirm>
            </div>
          </template>
        </template>
      </a-table>
    </div>
  </div>
</template>

<style scoped lang="scss">
.rushes-page {
  margin: 0 20px;
  &__create-button {
    display: flex;
    justify-content: flex-end;
    padding: 10px 20px;
  }
  &__action-buttons {
    display: flex;
    flex-direction: row;
  }
}

button:last-child {
  margin-left: 20px;
}

</style>
